import { render, staticRenderFns } from "./StockToggleButtonField.vue?vue&type=template&id=83280350&scoped=true&"
import script from "./StockToggleButtonField.vue?vue&type=script&lang=ts&"
export * from "./StockToggleButtonField.vue?vue&type=script&lang=ts&"
import style0 from "./StockToggleButtonField.vue?vue&type=style&index=0&id=83280350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83280350",
  null
  
)

export default component.exports